module.exports = __webpack_public_path__ + "static/media/now-full.619d1d07.jpg";